import React from "react";
import './handwave-animation.css';


const AboutMe = () => {
    return (
        <div>
            <div className="bg-[#add3f7] bg-cover bg-center md:mt-6 gap-11 w-full flex flex-col-reverse md:flex-row justify-center items-center md:py-[11.5vh] py-11 px-4 md:px-32 z-0">

                <div className="w-fit flex flex-col gap-5 md:w-[60vw] bg-gray-50 p-8 rounded-md shadow-md">

                    <h1 className="text-3xl font-[acme] text-black">
                        <div className="wave-animation">👋</div>
                        Hello, I'm Suraj Savji
                    </h1>
                    <p className="text-lg text-justify  font-[Noto Sans JP]  text-black ">
                    👨🏻‍🎓Recent IT graduate with a keen interest in backend development and Android development. 💻 My coding journey has been thrilling, bringing ideas to life through lines of code.                    </p>
                    <p className="text-lg text-justify font-[Noto Sans JP] text-black ">
                        🌐 As a backend enthusiast, I specialize in creating scalable solutions using the power of Node.js and Python. From building robust APIs to managing databases, I thrive on constructing the foundation that drives seamless applications.
                    </p>
                    <p className="text-lg text-justify  font-[Noto Sans JP] text-black ">
                        📱 On the mobile front, my love for creating engaging user experiences comes to life in Android development. Proficient in Kotlin and Java, I enjoy transforming concepts into user-friendly apps that leave a lasting impression.
                    </p>
                    <p className="text-lg text-justify font-[Noto Sans JP] text-black ">
                        🧠 Beyond the code, my academic journey has nurtured a strong problem-solving mindset, and real-world projects have equipped me with adaptability in dynamic environments. Eager to contribute my skills to meaningful projects and explore the endless possibilities in the tech world.
                    </p>

                </div>
                <div className="bg-white  rounded-md overflow-hidden shadow-md">
                    <img className="md:w-full md:h-[78vh] h-fit mt-0 w-screen object-cover" src="/assests/My_Image.png" alt=" " />

                </div>

            </div>
        </div>
    )
}

export default AboutMe;